import ReactApexChart from "react-apexcharts";
import { useChart } from "../chart";
import { cyberColors, CYBER_FONT } from "../../styles/cyberTheme";

export default function MemberMonthlyPlayTimeChart({ data = [] }) {
    const categories = data.map((item) => item.month);
    const seriesData = data.map((item) => {
        const seconds = Number(item.play_duration) || 0;
        return parseFloat((seconds / 60).toFixed(1));
    });

    const chartOptions = useChart({
        chart: {
            type: "bar",
            foreColor: cyberColors.muted.textBright,
            fontFamily: CYBER_FONT,
        },
        colors: [cyberColors.cyan],
        plotOptions: {
            bar: {
                borderRadius: 4,
                columnWidth: "55%",
            },
        },
        xaxis: {
            categories,
            labels: {
                style: { colors: cyberColors.muted.textBright, fontSize: "10px" },
                rotate: -45,
            },
        },
        yaxis: {
            title: {
                text: "分鐘",
                style: { color: cyberColors.cyan, fontFamily: CYBER_FONT },
            },
            labels: {
                style: { colors: cyberColors.muted.textBright },
            },
        },
        title: {
            text: "月度參與時數（分鐘）",
            align: "center",
            style: {
                color: cyberColors.cyan,
                fontFamily: CYBER_FONT,
                fontSize: "14px",
                fontWeight: 700,
            },
        },
        grid: {
            borderColor: cyberColors.purple.border,
        },
        tooltip: {
            theme: "dark",
            y: {
                formatter: (val) => `${val} 分鐘`,
            },
        },
    });

    return (
        <ReactApexChart
            type="bar"
            series={[{ name: "參與時數", data: seriesData }]}
            options={chartOptions}
            height={280}
        />
    );
}
